import { __extends } from "tslib";
import { SlotTraitInfo } from './SlotTraitInfo';
var ClassTraitInfo = /** @class */ (function (_super) {
    __extends(ClassTraitInfo, _super);
    function ClassTraitInfo(abc, kind, multiname, slot, classInfo) {
        var _this = _super.call(this, abc, kind, multiname, slot, abc.getMultiname(0), 0, -1) || this;
        _this.classInfo = classInfo;
        return _this;
    }
    return ClassTraitInfo;
}(SlotTraitInfo));
export { ClassTraitInfo };
